/**
 * @internal
 */
export const SchemasRoot = 'https://json-schemas.lens.dev';
